// extracted by mini-css-extract-plugin
module.exports = {"occupation-check-list":"occupation-check-list","occupation-check-list__medium-heading":"occupation-check-list__medium-heading"};